<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MarkingStatusBadge',
  props: {
    status: String,
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('labelArchive', [
      'labelArchiveStatuses',
    ]),
    statusColor() {
      const status = this.labelArchiveStatuses.find(s => s.id === this.status);
      return status?.color || '#171717';
    },
    statusIcon() {
      const status = this.labelArchiveStatuses.find(s => s.id === this.status);
      return status?.icon || 'fas fa-question';
    },
  },
};
</script>

<template>
  <div
    class="status-badge"
    :class="{
      'status-badge--small': small,
    }"
    :style="{
      backgroundColor: statusColor,
    }"
  >
    <i
      :class="statusIcon"
      class="fa-fw"
    />
    <span>
      {{ status || '---' }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.status-badge {
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
  margin-bottom: 6px;

  i {
    margin-right: 4px;
  }

  &--small {
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 500;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    margin-bottom: -2px;
  }
}
</style>
